module.exports = __webpack_public_path__ + "images/new_sku-66ead822.svg";